export const APPEND_ARTIFACTS = 'APPEND_ARTIFACTS';
export const REMOVE_ARTIFACTS = 'REMOVE_ARTIFACTS';
export const CLEAR_ARTIFACTS = 'CLEAR_ARTIFACTS';
export const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/;

export const READ_ARTIFACT = 'READ';
export const DOWNLOAD_ARTIFACT = 'DOWNLOAD';
